import {EnvModel} from './environment.model';

export const environment: EnvModel = {
  production: true,
  baseUrl: 'https://api-test-759480611317.europe-west1.run.app'
};
